import { grayOp06NonTransp, white } from 'styles/theme/colors'

export const setBodyColor = ({ isLight }) => {
  if (process.browser) {
    document.body.style.backgroundColor = isLight ? white : grayOp06NonTransp
  }
}
